import { ANALYTICS_EVENTS } from 'dpl/constants/analytics';

import { FOLLOWABLE_TYPES } from './constants';

interface FavoriteAnalytics {
  addedEvent: string;
  removedEvent: string;
  idProperty?: string;
}

const BREEDER_FAVORITE_ANALYTICS: FavoriteAnalytics = {
  addedEvent: ANALYTICS_EVENTS.BREEDER_ADDED_TO_FAVORITES,
  removedEvent: ANALYTICS_EVENTS.BREEDER_REMOVED_FROM_FAVORITES
};

const FAVORITE_ANALYTICS_BY_TYPE: Record<string, FavoriteAnalytics> = {
  [FOLLOWABLE_TYPES.DOG]: {
    addedEvent: ANALYTICS_EVENTS.PUPPY_ADDED_TO_FAVORITES,
    removedEvent: ANALYTICS_EVENTS.PUPPY_REMOVED_FROM_FAVORITES,
    idProperty: 'dog_id'
  },
  [FOLLOWABLE_TYPES.LITTER]: {
    addedEvent: ANALYTICS_EVENTS.LITTER_ADDED_TO_FAVORITES,
    removedEvent: ANALYTICS_EVENTS.LITTER_REMOVED_FROM_FAVORITES,
    idProperty: 'litter_id'
  }
};

export function getFavoriteAnalytics(
  followableType: string,
  followableId: number
) {
  const { addedEvent, removedEvent, idProperty } =
    FAVORITE_ANALYTICS_BY_TYPE[followableType] ?? BREEDER_FAVORITE_ANALYTICS;

  return {
    addedEvent,
    removedEvent,
    idProperties: idProperty ? { [idProperty]: followableId } : {}
  };
}
